export const generateUniqueId = (): number => {
  return Math.floor(Math.random() * 1000000);
};
